import React, { useContext } from 'react';
import UserProvider from '../../context/UserContext';
import '../../dash.css';
import Cookies from 'js-cookie';
import { useAlert } from "react-alert";

const CardInfo = () => {
    const Data = useContext(UserProvider.context);
    const userData = Data.user
    const memberData = Data.member
    const alert = useAlert();

    function alertError(message){
        if (document.getElementById('__react-alert__').children.length === 0) {
            alert.error(message)
        }
    }

    async function JoinDiscord(){
        document.getElementsByClassName('join-discord-button')[0].disabled = true;
        const url = `${process.env.REACT_APP_API_URL}/join-discord/`

        fetch(url, {
            credentials: "include",
            method: 'POST'
            })
            .then(function (response) {
                if(response.status === 200){
                    if (document.getElementById('__react-alert__').children.length === 0) {
                        alert.success("Successfuly joined Discord")
                        window.open("https://discord.com/channels/702506735067332662");
                    }
                    document.getElementsByClassName('join-discord-button')[0].disabled = false;
                }
                else{
                    document.getElementsByClassName('join-discord-button')[0].disabled = false;
                    Cookies.remove('user_data', { path: '/', domain: '.infinitbot.com' })
                    Cookies.remove('session', { path: '/', domain: '.infinitbot.com' })
                    window.location.replace('/')
                }
            })
            .catch(err => {
                document.getElementsByClassName('join-discord-button')[0].disabled = false;
                Cookies.remove('user_data', { path: '/', domain: '.infinitbot.com' })
                Cookies.remove('session', { path: '/', domain: '.infinitbot.com' })
                window.location.replace('/')
            });
    }

    return(
        <div className="card-component">
            <div className="card-content">
                <h1 className="discord-tag">{userData.username}#{userData.discriminator}</h1>
                <h3 className="info-email">{memberData.email}</h3>
                <span className="tag">{memberData.role}</span>
                <div className="join-discord-holder">
                    <button className="join-discord-button" onClick={JoinDiscord}><i className="fab fa-discord"/>Join Discord</button>
                </div>
            </div>
        </div>
    )
};

export default CardInfo;